<template>
  <div>

    <v-select v-if="getField(field)" 
    :label="getLabel(field)" 
    :items="countries" :readonly="field ? field.READONLY : false"
    :disabled="field ? field.DISABLED : false" 
    :rules="getValidators(field)" :value="value" @input="updateValue" menu-props="content-class: widened-menu"/>




  </div>

</template>
<style scoped>
.widened-menu {
  min-width: 300px; /* Oder wie breit du es brauchst */
}
</style>
<script>
import { set } from 'lodash';
import fieldMixin from '../mixins/field';
import { readonly } from 'vue';


export default {
  name: 'aedCountrySelect',
  mixins: [fieldMixin],
  props: {
    /**
     * Field object containing the configuration for the select box (e.g., options, label).
     * @type {Object}
     */
    field: Object,

    /**
     * The current selected value in the select box.
     * @type {string}
     */
    value: String,
  },
  data() {
    return {
      countries: []
      // other data properties...
    };
  },
  mounted() {

    if (this.field && this.field.VALUE) {
      this.updateValue(this.field.VALUE);

    }
    this.setCountries();

  },
  methods: {
    setCountries() {
            this.countries = [];

            for (const key in this.field.OPTIONS) {
                if (this.field.OPTIONS.hasOwnProperty(key)) {
                    const value = key;
                    const text = key + " | " + this.field.OPTIONS[key];
                    this.countries.push({ text, value });
                }
            }


        },
    updateValue(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>